import { PlainMessage } from "@bufbuild/protobuf";
import { z } from "zod/v3";
import { InstanceMetadata, instanceMetadataSchema } from "../models/instanceMetadata";
import { createSchema, ZodOutputFor } from "../zod-utils";
import { InstanceListResponse } from "@opstel/gen/knop/ui/v1/api/instance_loading_pb";
import { ResponseStatus, responseStatusSchema } from "./util/responseStatus";

export interface Instances {
  status: ResponseStatus;
  instances: InstanceMetadata[];
}

const instanceListSchema = createSchema<Instances, PlainMessage<InstanceListResponse>>({
  instances: z.array(instanceMetadataSchema),
  status: responseStatusSchema,
}) satisfies ZodOutputFor<Instances>;

export function parseInstanceList(proto: PlainMessage<InstanceListResponse>): InstanceMetadata[] {
  return instanceListSchema.parse(proto).instances;
}
